define("shared/utils/array-filters/get-sum-of-extracted-values", ["exports", "shared/utils/array-filters/extract-values"], function (_exports, _extractValues) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getSumOfExtractedValues = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/array-filters/extract-values"eaimeta@70e063a35619d71f
  /**
   * Returns the sum of an array of objects with sub properties.
   */
  const getSumOfExtractedValues = (array, property) => {
    const filteredArray = (0, _extractValues.default)(array, property);
    return filteredArray.reduce((acc, increment) => acc + increment, 0);
  };
  _exports.getSumOfExtractedValues = getSumOfExtractedValues;
  var _default = _exports.default = getSumOfExtractedValues;
});